import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { DropdownMenuItem } from '../../ui/dropdown-menu';
import { Spinner } from '../Spinner';
export const LoadingDropdownMenuItem = forwardRef(({ loading, disabled, onClick, children, ...props }, forwardedRef) => {
    const [_loading, setLoading] = useState(false);
    return (_jsxs(DropdownMenuItem, { ref: forwardedRef, ...props, disabled: disabled || _loading, onClick: async (e) => {
            if (onClick) {
                try {
                    setLoading(true);
                    await onClick(e);
                }
                finally {
                    setLoading(false);
                }
            }
        }, children: [(_loading || loading) && _jsx(Spinner, {}), children] }));
});
